import apiClient from '../middleware/apiClient';
import { SWAPS, COTTON_SWAPS } from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import cottonFlagManager from '../helpers/featureFlags/cotton';

// Fetch Swaps
export const GET_SWAPS = 'GET_SWAPS';
export const GET_SWAPS_SUCCESS = 'GET_SWAPS_SUCCESS';
export const GET_SWAPS_FAILURE = 'GET_SWAPS_FAILURE';

function dispatchGetSwaps(isKotlinEnabled) {
  return {
    type: GET_SWAPS,
    payload: apiClient.fetch(isKotlinEnabled ? COTTON_SWAPS : SWAPS, {
      headers: {
        Accept: 'application/json; v=3',
        'api-version': '3', // SHAME: workaround until codebig is fixed
      },
    }),
  };
}

function dispatchGetSwapsSuccess(account) {
  return {
    type: GET_SWAPS_SUCCESS,
    payload: account,
  };
}

function dispatchGetSwapsFailure(error) {
  return {
    type: GET_SWAPS_FAILURE,
    payload: error,
  };
}

export const getSwaps = () => async (dispatch, getState) => {
  // TODO update to cache
  if (getState().swaps.cached) {
    return null;
  }

  try {
    if (cottonFlagManager.swapsOrdersEnabled) {
      // Try Cotton API, fallback to Ruby API
      return dispatch(dispatchGetSwapsSuccess(await callApiWithFallback(
        dispatch,
        () => dispatchGetSwaps(true), // Cotton API call
        () => dispatchGetSwaps(false), // Ruby API call
        'swap_orders',
      )));
    }
    // Only call Ruby API
    return dispatch(dispatchGetSwapsSuccess(await dispatch(dispatchGetSwaps(false)).payload));
  } catch (error) {
    return dispatch(dispatchGetSwapsFailure(error));
  }
};
